import { EventSeriesCadenceUnit } from 'types/EventSeries';
import { MAX_CADENCE_BY_UNIT } from './agreementsConstants';

export const clampCadenceToUnit = (cadence: number | undefined, unit: EventSeriesCadenceUnit): number | undefined =>
  typeof cadence === 'number' && cadence > MAX_CADENCE_BY_UNIT[unit] ? MAX_CADENCE_BY_UNIT[unit] : cadence;

export const useCadenceUnitClamp =
  (getCadence: () => number | undefined, setCadence: (value: number) => void) =>
    (unitOnChange: (value: EventSeriesCadenceUnit) => void) =>
      (value: EventSeriesCadenceUnit) => {
        unitOnChange(value);
        const currentCadence = getCadence();
        const clamped = clampCadenceToUnit(currentCadence, value);

        if (clamped !== currentCadence) {
          setCadence(clamped as number);
        }
      };
